/**
 * Text for jsPDF standard fonts (WinAnsi): replace punctuation outside Latin-1 that renders as junk.
 * Preserves newlines so multi-line blocks still wrap per paragraph.
 */
function cleanLine(line) {
  return (
    line
      .normalize('NFC')
      .replace(/[\uFEFF\u200B-\u200F\u2060]/g, '')
      .replace(/\u00A0/g, ' ')
      .replace(/[\u2190-\u21FF]/g, ' -> ')
      .replace(/[\u2013\u2014\u2015]/g, '-')
      .replace(/[\u00B7\u2022\u2219\u2024]/g, ' * ')
      .replace(/[\u2018\u2019\u201C\u201D]/g, "'")
      .replace(/ +/g, ' ')
      .trim()
  );
}

export function pdfSafeText(input) {
  return String(input ?? '')
    .replace(/\r\n/g, '\n')
    .split('\n')
    .map((ln) => cleanLine(ln))
    .join('\n');
}
